import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=11a5b04e&"
import script from "./certificate.js?vue&type=script&lang=js&"
export * from "./certificate.js?vue&type=script&lang=js&"
import style0 from "./certificate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports